/*
 * Copyright (c) 2017 DV Bern AG, Switzerland
 *
 * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich
 * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt
 * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in
 * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur
 * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.
 *
 */
import {ILogService} from 'angular';
import ErrorService from '../errors/service/ErrorService';

export default class PasswordStrengthService {

    static $inject = ['ErrorService', '$log'];
    /* @ngInject */
    constructor(private errorService: ErrorService, private $log: ILogService) {
    }

    public checkIfValid(password?: string, passwordRepeat?: string): boolean {
        this.errorService.clearAll();
        if (password === undefined || passwordRepeat === undefined) {
            this.$log.debug('not all passwords were defined');
            return false;
        }

        if (password !== passwordRepeat) {
            this.errorService.addMesageAsError('ERROR_PW_SAME');
            return false;
        }
        if (!this.hasNumber(password)) {
            this.errorService.addMesageAsError('ERROR_PW_RESTRICTIONS');
            return false
        }
        if (!this.hasChar(password)) {
            this.errorService.addMesageAsError('ERROR_PW_RESTRICTIONS');
            return false
        }
        if (!this.isLongEnough(password)) {
            this.errorService.addMesageAsError('ERROR_PW_RESTRICTIONS');
            return false;
        }

        return true;
    }

    private hasNumber(passwd: string): boolean {
        let matches: RegExpMatchArray | null = passwd.match(/\d+/g);
        if (matches != null) {
            return true;
        }
        return false;
    }

    private hasChar(passwd: string): boolean {

        let matches: RegExpMatchArray | null = passwd.match(/[A-Za-z]+/g);
        if (matches != null) {
            return true;
        }
        return false;
    }

    private isLongEnough(passwd: string): boolean {
        if (passwd.length < 8) {
            return false;
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/core/service/PasswordStrengthService.ts